import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Submit16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.2501 3V8.75H4.31077L7.03044 6.03033L5.96978 4.96967L1.43945 9.5L5.96978 14.0303L7.03044 12.9697L4.31078 10.25H14.7501V3H13.2501Z'
      fill='currentColor'
    />
  </Svg>
);

Submit16.displayName = 'Submit16';
export default Submit16;
